import { snapshot } from 'valtio';
import { navigateToResolvedIssues } from '../../../common/routing/app-navigator';
import { FilterTypeToFilter } from '../../../common/filters-utils/filters-utils';
import {
  clearFilters,
  setModalVisibility,
  setSelectedIssue,
} from '../../active-issues/store-actions/issue-store-actions';
import ResolvedIssuesStore from '../stores/resolved-issues-store';
import {
  loadFiltersResolved,
  loadIssuesResolved,
} from './resolved-issues-actions';

export const onChangeResolvedFilter = (
  e: React.ChangeEvent<HTMLInputElement>,
) => {
  if (ResolvedIssuesStore.filterIssuesBy[e.target.id]) {
    const index = ResolvedIssuesStore.filterIssuesBy[e.target.id].indexOf(
      e.target.value,
    );
    if (index !== -1) {
      ResolvedIssuesStore.filterIssuesBy[e.target.id].splice(index, 1);
    } else {
      ResolvedIssuesStore.filterIssuesBy[e.target.id].push(e.target.value);
    }
  } else {
    ResolvedIssuesStore.filterIssuesBy[e.target.id] = [e.target.value];
  }
  navigateToResolvedIssues(ResolvedIssuesStore.filterIssuesBy);
  if (ResolvedIssuesStore.selectedIssueId) {
    selectedIssueFilter();
  } else {
    loadIssuesResolved({ update: true });
  }
  loadFiltersResolved();
};

const selectedIssueFilter = async () => {
  await loadIssuesResolved({ update: true });
  const { issues, selectedIssueId } = snapshot(ResolvedIssuesStore);
  const selectedIssueAfterFilter = issues.find(
    issue => issue.issueId === selectedIssueId,
  );
  if (selectedIssueAfterFilter === undefined) {
    setModalVisibility(false);
    setSelectedIssue(null);
  }
};

export const setInitialFilters = (encodedFilters: string | null) => {
  if (!encodedFilters) return;
  let filters = {};
  try {
    filters = JSON.parse(decodeURI(encodedFilters));
  } catch {}
  ResolvedIssuesStore.filterIssuesBy = filters;
};

export const handleChangeResolvedFilterSlider = (
  range: number[] | number,
  filterName: FilterTypeToFilter,
) => {
  ResolvedIssuesStore.filterIssuesBy[filterName] = {
    from: range[0],
    to: range[1],
  };

  const checkBusinessPriority =
    filterName === FilterTypeToFilter.BusinessPriority &&
    range[1] === 100 &&
    range[0] === 0;

  if (checkBusinessPriority) {
    clearFilters();
  }
  navigateToResolvedIssues(ResolvedIssuesStore.filterIssuesBy);
  loadIssuesResolved({ update: true });
  loadFiltersResolved();
};

export const setCategoryFilter = (category: string) => {
  ResolvedIssuesStore.filterIssuesBy['categories'] = [category];
};
